import { decryptParams } from "@/utils/encrypt-util";

/**
 * 解密路由参数
 * @returns 
 */
export const useDecryptRouteData = <T = any>(name: string) => {
  const searchParams = new URLSearchParams(location.search)
  const value = searchParams.get(name)

  if (!value) {
    return { data: null }
  }

  const data = decryptParams<T>(value || '');

  return {
    data
  }
}